export default __webpack_public_path__ + "static/portfolio_gallery_32-4a3ad9cd8f8fb4f034abaeeddb3cb977.jpg";